export const HOST = process.env.NODE_ENV === "development" ? "http://localhost:11001" : "https://be.lcmswallet.co.kr";
export const CLIENT_HOST = "https://www.lcmswallet.co.kr";
export const NODE_ENDPOINT = "https://mainnet.infura.io/v3/5fb3aad80e014496bca34fb930bec822";
export const CHAIN_NAME = "mainnet";
export const ETHERSCAN_TX_URL = `https://etherscan.io/tx/`;
export const CHAIN_ID = 1;
export const CONTRACT_ADDRESS = [
  { address: "0x86911B82BfA596e9377836838AC1f0d9AD4Ecc19", name: "lcms" },
  { address: "0x27427ecf9dabc604df22e300a6bd0694b24eb1b1", name: "esg" },
  { address: "0xdAC17F958D2ee523a2206206994597C13D831ec7", name: "usdt" },
];

export const ETHERSCAN_API_ENDPOINT = ({ address, page, offset, sort }) =>
  `https://api.etherscan.io/api?module=account&action=tokentx&address=${address}&page=${page}&offset=${offset}&sort=${sort}&apikey=A8AD4BGWPNHFXW7179BEQ32BRX3HN3IP6C`;

export const TOKEN_ENDPOINT = (address) => `https://etherscan.io/token/${address}`;

export const ETHERSCAN_API_ENDPOINT_ETH = ({ address, page, offset, sort }) =>
  `https://api.etherscan.io/api?module=account&action=txlist&address=${address}&startblock=0&endblock=99999999&sort=${sort}&page=${page}&offset=${offset}&apikey=A8AD4BGWPNHFXW7179BEQ32BRX3HN3IP6C`;
export const ETHERSCAN_ADDRESS_URL = `https://etherscan.io/address/`;

/***********
 *
 *
 */

// export const ETHERSCAN_API_ENDPOINT_ETH = ({ address, page, offset, sort }) =>
//   `https://api-ropsten.etherscan.io/api?module=account&action=txlist&address=${address}&startblock=0&endblock=99999999&sort=${sort}&page=${page}&offset=${offset}&apikey=A8AD4BGWPNHFXW7179BEQ32BRX3HN3IP6C`;

// export const ETHERSCAN_API_ENDPOINT = ({ address, page, offset, sort }) =>
//   `https://api-ropsten.etherscan.io/api?module=account&action=tokentx&address=${address}&page=${page}&offset=${offset}&sort=${sort}&apikey=A8AD4BGWPNHFXW7179BEQ32BRX3HN3IP6C`;

// export const CONTRACT_ADDRESS = [
//   { address: "0x7731172bb5cb7be3e35358904d0a98c61738cdd0", name: "lcms" },
//   { address: "0x333d45e8000d6df37cfce30131c7b0223ef98db5", name: "usdt" },
//   { address: "0x7731172bb5cb7be3e35358904d0a98c61738cdd0", name: "esg" },
// ];

// export const HOST = "http://localhost:11001";
// export const CLIENT_HOST = "http://localhost:11000";
// export const CHAIN_ID = 3;
// export const NODE_ENDPOINT = "https://ropsten.infura.io/v3/5fb3aad80e014496bca34fb930bec822";
// export const CHAIN_NAME = "ropsten";
// export const ETHERSCAN_TX_URL = `https://ropsten.etherscan.io/tx/`;
// export const TOKEN_ENDPOINT = (address) => `https://ropsten.etherscan.io/token/${address}`;
// export const ETHERSCAN_ADDRESS_URL = `https://ropsten.etherscan.io/address/`;

export const GAS_PRICE_API_ESC =
  "https://api.etherscan.io/api?module=gastracker&action=gasoracle&apikey=8J1TDDQSKHWCVC78VQR2XII34A5I5JIWFA";

export const GAS_PRICE_API =
  "https://data-api.defipulse.com/api/v1/egs/api/ethgasAPI.json?api-key=42947d20540af4c29a597d1fbc965852a549359a7556d6bde3a864a606b7";
export const PAGE_UNIT = 5;
export const NOTICE_PAGE_UNIT = 10;
export const DONATION_LIST_PAGE_UNIT = 10;
export const ADMIN_PAGE_UNIT = 15;
export const ADMIN_EXCHANGE_UNIT = 10;
export const SECOND = 1000;
export const MINUTE = 60;

export const AMOUNT_REGEX = /^[]?\d*(\.?\d*)$/;
export const NUMBER_REGEX = /^[0-9]+$/;
